import type { Transition } from 'framer-motion';

export const SHORTLIST_EASE = [0.22, 1, 0.36, 1] as const;

export const SHORTLIST_LOAD_DELAYS = {
  hero: 0.07,
  jobContext: 0.1,
  list: 0.14,
  cardsBase: 0.2,
  detailBack: 0,
  detailHeader: 0.07,
  detailStrengths: 0.14,
  detailWorkHistory: 0.2,
} as const;

export function getShortlistRevealTransition(
  prefersReducedMotion: boolean | null,
  delay = 0,
): Transition {
  if (prefersReducedMotion) {
    return { duration: 0 };
  }

  return {
    duration: 0.45,
    delay,
    ease: SHORTLIST_EASE,
  };
}

export function getShortlistRevealInitial(
  prefersReducedMotion: boolean | null,
) {
  return prefersReducedMotion ? false : { opacity: 0, y: 12 };
}

export const shortlistRevealVisible = { opacity: 1, y: 0 };
